module.exports = __webpack_public_path__ + "img/signature2.249a62ab.png";